export default __webpack_public_path__ + "static/logo-1775b9df454c7f12cae8514ee277ece8.svg";